import axios from 'axios';
import config from '../config';

const base = config.apiUrl;
const cfg = { withCredentials: true };

export const getPlanInfo = () => async () => {
  const res = await axios.get(`${base}/api/v1/subscription/plan`, cfg);
  return res.data;
};

export const getMySubscription = () => async () => {
  const res = await axios.get(`${base}/api/v1/subscription/me`, cfg);
  return res.data; // { hasAccess, subscription }
};

export const createSubscription = (interval = 'monthly') => async () => {
  const res = await axios.post(`${base}/api/v1/subscription/create`, { interval }, cfg);
  return res.data; // { subscriptionId, key, shortUrl, trialEndsAt }
};

export const verifySubscription = (payload) => async () => {
  const res = await axios.post(`${base}/api/v1/subscription/verify`, payload, cfg);
  return res.data;
};

export const cancelSubscription = () => async () => {
  const res = await axios.post(`${base}/api/v1/subscription/cancel`, {}, cfg);
  return res.data;
};

export const paypalGetPlanId = (interval = 'monthly') => async () => {
  const res = await axios.get(`${base}/api/v1/subscription/paypal/plan?interval=${interval}`, cfg);
  return res.data; // { planId, interval }
};

export const paypalRecordSubscription = (subscriptionID, interval) => async () => {
  const res = await axios.post(`${base}/api/v1/subscription/paypal/record`, { subscriptionID, interval }, cfg);
  return res.data;
};

// Lazy-load the Razorpay checkout script once.
export const loadRazorpay = () =>
  new Promise((resolve) => {
    if (window.Razorpay) return resolve(true);
    const s = document.createElement('script');
    s.src = 'https://checkout.razorpay.com/v1/checkout.js';
    s.onload = () => resolve(true);
    s.onerror = () => resolve(false);
    document.body.appendChild(s);
  });
